<template>
  <div :class="['attachments-block', {loading: isLoading}]">
    <div v-if="isLoading" class="loading-card d-flex justify-content-center align-items-center">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
    </div>
    <attachments-loader-card
      v-if="(!isLinkFormDisplayed && !isEditFileFormDisplayed)"
      @file-loaded="saveFiles"
      @open-link-form="openLinkForm"
      @close="closeAttachments"
      @save-external-links="saveExternalLinks"
      :item-data="attachment"
    />
    <attachment-link-form
      :attachment="attachment"
      v-if="isLinkFormDisplayed"
      @save="saveLink"
      @cancel="closeAttachments"
    />
    <attachment-edit-file-form
      :attachment="attachment"
      v-if="isEditFileFormDisplayed"
      @save="updateFile"
      @cancel="closeAttachments"
    />
  </div>
</template>

<script>
import AttachmentsLoaderCard from '@/components/attachmentsNew/AttachmentsLoaderCard'
import AttachmentLinkForm from '@/components/attachmentsNew/AttachmentLinkForm'
import AttachmentEditFileForm from '@/components/attachmentsNew/AttachmentEditFileForm'
import BaseComponent from '@/components/commentsNew/BaseComponent'
import api from '@/services/api.service'
export default {
  name: 'Attachments',
  extends: BaseComponent,
  components: { AttachmentEditFileForm, AttachmentLinkForm, AttachmentsLoaderCard },
  props: {
    attachment: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // If itemType and itemId are specified we create an attachment that initially connected to some item (lesson, unit ...)
    // Otherwise we create ann attachment which is not connected anywhere and then connect it manually (comments_
    objectType: {
      type: String,
      default: ''
    },
    objectId: {
      type: [String, Number],
      default: ''
    },
    url: {
      type: String,
      default: 'attachments'
    }
  },
  data () {
    return {
      isLinkFormDisplayed: false,
      isEditFileFormDisplayed: false,
      isLoading: false,
      yearId: (new URLSearchParams(window.location.search)).get('yearId')
    }
  },
  created () {
    if (this.attachment.id) {
      const type = this.attachment.attachmentType || this.attachment.AttachmentType
      switch (type) {
        case 'file':
          this.isEditFileFormDisplayed = true
          break
        case 'link':
          this.isLinkFormDisplayed = true
          break
      }
    }
  },
  methods: {
    openLinkForm () {
      this.isLinkFormDisplayed = true
    },
    saveLink (data) {
      this.isLoading = true
      if (this.objectType && this.objectId) {
        data.objectId = this.objectId
        data.objectType = this.objectType
      }
      if (this.yearId) {
        data.yearId = this.yearId
      }
      const { id } = this.attachment

      let method = 'post'
      let path = 'attachment/link'
      let eventToEmit = 'attachment-added'
      if (id) {
        // Update existing link attachment
        method = 'put'
        path += '/' + id
        eventToEmit = 'attachment-updated'
      }
      this.$http[method](path, data)
        .then(response => {
          this.isLoading = false
          this.$emit(eventToEmit, response.data.data)
        })
        .catch(error => console.error(error))
    },
    async saveExternalLinks (data) {
      this.isLoading = true

      const payload = {
        ...data,
        ...this.attachment,
        objectId: this.objectId,
        objectType: this.objectType
      }

      this.$http.post('attachment/storeMany', { ...payload })
        .then(response => {
          this.isLoading = false
          this.$emit('attachment-added', response.data.data)
        })
        .catch(error => console.error(error))
    },
    updateFile (Description) {
      this.$http.put(`attachment/file/${this.attachment.id}` + (this.yearId ? `?yearId=${this.yearId}` : ''),
        { Description })
        .then(response => {
          this.isLoading = false
          this.$emit('attachment-updated', response.data.data)
        })
        .catch()
    },
    closeAttachments () {
      this.$emit('close')
    },
    async saveFiles (formData) {
      this.isLoading = true
      const { data } = await api.attachment.createFile(Object.assign(formData, this.attachment))
      const attachments = data.data
      // if we are inside (lesson, unit ...)
      // We get array of created file attachments
      // And should connect these just created files to the instance of our object
      if (this.objectType && this.objectId) {
        const attachmentsIds = attachments.map(el => el.id)
        const data = {
          attachmentsIds,
          objectId: this.objectId,
          objectType: this.objectType
        }
        if (this.yearId) {
          data.yearId = this.yearId
        }
        const result = await this.$http.put('attachments/add-owner', data)
        this.$emit('attachment-added', result.data.data)
        return
      }
      this.isLoading = false
      this.$emit('attachment-added', attachments)
    }
  }
}
</script>

<style scoped lang="scss">
.attachments-block {
  position: relative;
  width: 240px;
  font-size: 12px;
  &.loading {
    opacity: 0.5
  }
}
.loading-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.1);
  z-index: 1;
}
</style>
